import defaultTheme from '@mui/material/styles/defaultTheme.js';
import {deepmerge} from '@mui/utils';

export const DEFAULT_FONT = 'Inter Tight Variable';
export const DEFAULT_FONT_FAMILY = `'${DEFAULT_FONT}', sans-serif`;

export default deepmerge(defaultTheme.typography, {
  fontFamily: DEFAULT_FONT_FAMILY,
  h1: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  h2: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  h3: {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontWeight: 500,
  },
  h4: {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontWeight: 500,
  },
  h5: {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontWeight: 500,
  },
  h6: {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontWeight: 400,
  },
  subtitle1: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  subtitle2: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  body1: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  body2: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  button: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  caption: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  overline: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  overline2: {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSize: defaultTheme.typography.pxToRem(16),
    fontWeight: 400,
    lineHeight: 2.66,
    letterSpacing: '0.0625em',
    textTransform: 'uppercase',
  },
});
